import {
  DEFAULT_PLAN_KEY,
  DEFAULT_TRIAL_DAYS,
  PATH_ANALYSIS_AVAILABLE,
  TRIAL_DAYS_LEFT_TO_SHOW_NOTICE,
} from './pricing';
import { DEFAULT_PLAN_KEY_SHOW_USAGE_FEE, DEFAULT_USAGE_FEE_PLAN_KEY } from './usage-fee';
import { COMPARE_PLAN_SHOW_USAGE_FEE } from './pricing-comparison';
import { NUMBER_OF_LIMIT_INFINITY } from './limitation';

export const CONFIG_PRICING = {
  COMPARE_PLAN_SHOW_USAGE_FEE,
  NUMBER_OF_LIMIT_INFINITY,
  PATH_ANALYSIS_AVAILABLE,
  TRIAL_DAYS_LEFT_TO_SHOW_NOTICE,

  DEFAULT_PLAN_KEY,
  DEFAULT_PLAN_KEY_SHOW_USAGE_FEE,
  DEFAULT_TRIAL_DAYS,
  DEFAULT_USAGE_FEE_PLAN_KEY,
};
